import React from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {createSelector} from 'reselect'
import {reduxForm, Field, getFormSyncErrors} from 'redux-form'
import {Button, Tooltip, FieldStatus, ClearIcon} from 'rambler-ui'
import {fieldInvalid} from 'utils/validation'
import RowButton from 'components/RowButton'
import InlineForm from 'components/InlineForm'
import TextField from 'components/TextField'
import styles from './styles.css'

function ChangeName({
  errors,
  submitting,
  buttonTooltip,
  onClose,
  handleSubmit
}) {
  const error = errors.firstname || errors.lastname
  const status = error ? 'error' : null

  return (
    <InlineForm onSubmit={handleSubmit}>
      <FieldStatus type={status} message={error}>
        <div className={styles.group}>
          <Field
            placeholder="Имя"
            component={TextField}
            name="firstname"
            autoFocus
            validate={fieldInvalid}
            meta={{error, touched: true}}
            statusClassName={styles.status}
          />
          <Field
            placeholder="Фамилия"
            component={TextField}
            name="lastname"
            validate={fieldInvalid}
            meta={{error, touched: true}}
            statusClassName={styles.status}
          />
        </div>
      </FieldStatus>
      <Tooltip
        position="bottom"
        content={buttonTooltip}
        isOpened={!!buttonTooltip}>
        <Button
          type="primary"
          buttonType="submit"
          tabIndex="0"
          loading={submitting}
          disabled={submitting}>
          Сохранить
        </Button>
      </Tooltip>
      <RowButton label="Закрыть" onClick={onClose}>
        <ClearIcon />
      </RowButton>
    </InlineForm>
  )
}

ChangeName.propTypes = {
  tooltip: PropTypes.string,
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

const mapStateToProps = createSelector(
  getFormSyncErrors('changeName'),
  (errors) => ({errors})
)

const withConnect = connect(mapStateToProps)
const withForm = reduxForm({form: 'changeName'})

export default compose(withConnect, withForm)(ChangeName)
